import { useSelector } from "react-redux";
import { isSweepstakesApplication } from "../utils/appConfigUtils";

/** True when `app_currency_config.application_type` is sweepstakes (Redux `state.config.appConfig`). */
export function useIsSweepstakesApplication() {
  const appConfig = useSelector((state) => state.config.appConfig);
  return isSweepstakesApplication(appConfig);
}
